import React from 'react';
import SplitModelSetSlideTable from 'components/SplitModelSetSlideTable';
import { CaseMilestoneAction } from 'pages/Cases/hooks/useGetCases';

export type ModelSetsTableProps = {
  readonly action: CaseMilestoneAction;
  readonly modelSetName: string;
  readonly options?: number[];
};

export function ModelSetsTable({
  action,
  modelSetName,
  options,
}: ModelSetsTableProps): React.ReactElement {
  // Filter the data based on modelSetName and options
  const filteredData = React.useMemo(() => {
    // Find the specific model set by name
    const targetModelSet = action.value.model_set_holdings.find(
      (modelSet: any) => modelSet.model_set_name === modelSetName
    );

    if (!targetModelSet) {
      return action; // Return original if not found
    }

    // Filter portfolio options if provided
    const filteredPortfolioOptions = options?.length
      ? targetModelSet.portfolio_options.filter((option: any) =>
          options.includes(option.option)
        )
      : targetModelSet.portfolio_options;

    // Create filtered action with only the target model set
    const filteredAction = {
      ...action,
      value: {
        ...action.value,
        model_set_holdings: [{
          ...targetModelSet,
          portfolio_options: filteredPortfolioOptions
        }]
      }
    };

    return filteredAction;
  }, [action, modelSetName, options]);

  return (
    <SplitModelSetSlideTable
      data={filteredData}
      dataType="cases"
      modelSetName={modelSetName}
      slideMode={true}
      fontSize={14}
    />
  );
}
